// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * Flare API
 * API for Flare learning platform
 * OpenAPI spec version: 0.1.0
 */
import type { StudentCommentOutput } from './studentCommentOutput';
import type { LegacyScoresOutput } from './legacyScoresOutput';
import type { HighlightingOutput } from './highlightingOutput';

export interface AutograderStudentFeedback {
  id?: string;
  studentComment: StudentCommentOutput;
  legacyScores: LegacyScoresOutput;
  highlighting: HighlightingOutput;
}
